import React, { useMemo } from "react";
import { toInstant } from "utils/time-utils";
import UniversalTableDatasetButtonComponent from "./UniversalTableDatasetButtonComponent";
import UniversalTableDatasetButtonWrapper from "./UniversalTableDatasetButtonWrapper";
import { DatasetButtonProps } from "./UniversalDatasetTableTypes";

const DatasetButton = ({
  dataset,
  columnIndex,
  rowData,
  compactMode,
  maxAge,
  isExpired,
  onExpiredChange,
}: DatasetButtonProps) => {
  const datasetData = dataset?.data?.length ? dataset.data[0] : null;
  const datasetTime = useMemo(() => toInstant(datasetData?.key), [datasetData]);
  const datasetId = useMemo(
    () =>
      dataset
        ? `dataset-label-${dataset.identifier.split(":")[1]}-${dataset.identifier.split(":")[0]}`
        : null,
    [dataset]
  );

  const comProps = {
    columnIndex,
    rowData,
    compactMode,
    dataset,
    data: datasetData,
    time: datasetTime!,
  };

  return (
    <>
      {isExpired && (
        <UniversalTableDatasetButtonComponent {...comProps} id={datasetId ?? ""} isExpired={isExpired} />
      )}
      {!isExpired && (
        <UniversalTableDatasetButtonWrapper
          {...comProps}
          datasetId={datasetId ?? ""}
          maxAge={maxAge}
          onExpiredChange={onExpiredChange}
        />
      )}
    </>
  );
};

export default DatasetButton;
